import React from 'react'
import Video from "../Video";

export default function UserStream({ stream, user, mute, maximizeUserVideo }) {
    // Extract the actual MediaStream from the stream prop
  const mediaStream = stream?.current ? stream.current : stream;
  return (
    <div
          id="cam"
          className="bg-black text-white rounded shadow-sm position-relative"
          style={{
            height: "150px",
            width: "220px",
            marginRight: "15px",
            cursor: "pointer",
            overflow: "hidden",
          }}
          key={user._id}
          onClick={() => maximizeUserVideo(stream, user)}
        >
          {/* User Info Header */}
          <div
            className="d-flex align-items-center p-2 bg-dark position-absolute top-0 start-0 w-100"
          >
            {user?.imageSrc && user?.imageSrc !== "" ? (
              <div className="me-2">
                <img
                  src={user.imageSrc}
                  alt="user"
                  className="rounded-circle"
                  style={{
                    width: "28px",
                    height: "28px",
                    objectFit: "cover",
                  }}
                />
              </div>
            ) : (
              <div className="me-2">
                <div
                  className="d-flex justify-content-center align-items-center rounded-circle bg-primary text-white"
                  style={{ width: "28px", height: "28px", fontSize: "14px" }}
                >
                  {user?.contactName?.first?.charAt(0)?.toUpperCase()}
                </div>
              </div>
            )}
            <div className="fw-semibold small text-truncate">
              {user?.contactName?.first + " " + user?.contactName?.last}
            </div>
          </div>
  
          {/* Video or Message */}
          <div
            style={{
              position: "relative",
              top: "25px",
              zIndex: 1,
            }}
          >
            {stream ? (
              <Video
                stream={mediaStream}
                muted={mute === true}
                style={{
                  width: "220px",
                  height: "140px",
                  marginTop: "-30px",
                  transform: "rotateY(180deg)",
                  objectFit: "cover",
                  borderRadius: "0 0 6px 6px",
                }}
              />
            ) : (
              <div
                className="d-flex justify-content-center align-items-center text-muted"
                style={{ height: "100%", fontSize: "14px" }}
              >
                Camera is off
              </div>
            )}
          </div>
        </div>
  )
}
